import { createI18n } from 'vue-i18n';

const messages = {
    ko: {
        common: {
            lang: 'KOR',
            name: 'name',
            title: 'title',
        },
        offline: {
            title: '이지체크(EasyCheck)',
        },
    },
    en: {
        common: {
            lang: 'ENG',
            name: 'nameEn',
            title: 'titleEn',
        },
        offline: {
            title: 'EasyCheck',
        },
    },
};

const i18n = createI18n({
    locale: 'ko',
    messages,
});

export default i18n;
